var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.watchSubmitLoader)?_c('div',{staticStyle:{"display":"flex","justify-content":"center","margin-top":"250px"}},[_c('CustomLoaderComponent')],1):_c('div',{staticStyle:{"overflow":"hidden","font-family":"'VzNHGeDS-reg11'"}},[_c('div',{attrs:{"id":"vz-gh20"}}),_c('div',[_c('PwdLessLogin')],1),_c('div',{attrs:{"id":"vz-gf20"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }